/**
 * PDP size drawer — syncs list rows, closes on select, updates the trigger label with chosen size.
 */
(function () {
  'use strict';

  function valueElForDrawerId(drawerId) {
    return (
      document.querySelector('[data-pdp-size-drawer-value="' + drawerId + '"]') ||
      document.getElementById(drawerId + '-value')
    );
  }

  function triggerForDrawerId(drawerId) {
    return document.querySelector('[data-pdp-size-drawer-id="' + drawerId + '"]');
  }

  function setTriggerSize(drawerId, sizeText) {
    var text = (sizeText || '').trim();
    var valueEl = valueElForDrawerId(drawerId);
    var trigger = triggerForDrawerId(drawerId);

    if (valueEl) {
      valueEl.textContent = text;
      valueEl.classList.toggle('is-visible', text.length > 0);
    }

    if (trigger) {
      trigger.classList.toggle('has-selected-size', text.length > 0);
      var labelEl = trigger.querySelector('.product-size-drawer__trigger-label');
      if (text.length > 0 && labelEl) {
        trigger.setAttribute('aria-label', labelEl.textContent.trim() + ', ' + text);
      } else {
        trigger.removeAttribute('aria-label');
      }
    }
  }

  function syncTriggerFromInput(input) {
    if (!input || !input.checked) return;

    var drawer = input.closest('x-drawer.drawer--pdp-size, .drawer--pdp-size');
    var drawerId = drawer && drawer.id;
    if (!drawerId && input.form) {
      var trigger = input.form.querySelector('[data-pdp-size-drawer-id]');
      drawerId = trigger && trigger.getAttribute('data-pdp-size-drawer-id');
    }

    if (!drawerId) return;

    var label = input.closest('label');
    var sizeLabel = label && label.querySelector('.pdp-size-drawer__size-label');
    var sizeText = sizeLabel ? sizeLabel.textContent.trim() : '';

    if (!sizeText && input.labels && input.labels[0]) {
      var labelEl = input.labels[0].querySelector('.pdp-size-drawer__size-label');
      sizeText = labelEl ? labelEl.textContent.trim() : '';
    }

    setTriggerSize(drawerId, sizeText);
  }

  function syncAllTriggers(scope) {
    (scope || document).querySelectorAll('[data-pdp-size-drawer-id]').forEach(function (trigger) {
      var drawerId = trigger.getAttribute('data-pdp-size-drawer-id');
      var valueEl = valueElForDrawerId(drawerId);
      var text = valueEl ? valueEl.textContent.trim() : '';

      if (text) {
        setTriggerSize(drawerId, text);
        return;
      }

      var drawer = document.getElementById(drawerId);
      var checked = drawer && drawer.querySelector('.pdp-size-drawer__radio:checked');
      if (checked) {
        syncTriggerFromInput(checked);
      }
    });
  }

  function syncRowSelectedStates(list) {
    if (!list) return;

    list.querySelectorAll('label.pdp-size-drawer__row').forEach(function (row) {
      var input = row.querySelector('.pdp-size-drawer__radio');
      row.classList.toggle('pdp-size-drawer__row--selected', !!(input && input.checked));
    });

    list.querySelectorAll('.pdp-size-drawer__row-outer').forEach(function (outer) {
      var input = outer.querySelector('.pdp-size-drawer__radio:checked');
      var link = outer.querySelector('a.pdp-size-drawer__row');
      if (link) {
        link.classList.toggle('pdp-size-drawer__row--selected', !!input);
      }
    });
  }

  function syncDrawerListFromTemplate(template) {
    var drawerId = template.getAttribute('data-pdp-size-drawer-template');
    if (!drawerId) return;

    var drawer = document.getElementById(drawerId);
    if (!drawer) return;

    var list = drawer.querySelector('[data-pdp-size-drawer-list]');
    if (!list) return;

    list.innerHTML = template.innerHTML;
    syncRowSelectedStates(list);

    var checked = list.querySelector('.pdp-size-drawer__radio:checked');
    if (checked) {
      syncTriggerFromInput(checked);
    }
  }

  function syncDrawerLists(scope) {
    (scope || document).querySelectorAll('[data-pdp-size-drawer-template]').forEach(syncDrawerListFromTemplate);
    syncAllTriggers(scope);
  }

  function closeOpenSizeDrawers() {
    document.querySelectorAll('x-drawer.drawer--pdp-size[open]').forEach(function (drawer) {
      if (typeof drawer.hide === 'function') {
        drawer.hide();
      } else {
        drawer.removeAttribute('open');
      }
    });
  }

  function bindProductRerenderForms(scope) {
    (scope || document).querySelectorAll('product-rerender[observe-form]').forEach(function (rerenderEl) {
      var formId = rerenderEl.getAttribute('observe-form');
      var form = formId && document.getElementById(formId);
      if (!form || form.dataset.pdpSizeDrawerBound === 'true') return;

      form.dataset.pdpSizeDrawerBound = 'true';

      form.addEventListener('product:rerender', function () {
        window.requestAnimationFrame(function () {
          syncDrawerLists(rerenderEl);
        });
      });
    });
  }

  function init(scope) {
    syncDrawerLists(scope);
    bindProductRerenderForms(scope);

    (scope || document).querySelectorAll('[data-pdp-size-drawer-list]').forEach(syncRowSelectedStates);
  }

  document.addEventListener(
    'change',
    function (event) {
      var input = event.target;
      if (!(input instanceof HTMLInputElement)) return;
      if (!input.classList.contains('pdp-size-drawer__radio')) return;

      var list = input.closest('[data-pdp-size-drawer-list]');
      syncRowSelectedStates(list);
      syncTriggerFromInput(input);
      closeOpenSizeDrawers();
    },
    true,
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target) init(event.target);
  });
})();
